var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"small":"","label":"","outlined":"","color":"primary"}},[_vm._v(" "+_vm._s(_vm.label)+" - "+_vm._s(_vm._f("toINR")(_vm.inrValue))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }